export default __webpack_public_path__ + "static/media/swiss-flower-regular.b6fc7a3f.jpg";